// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/.pnpm/css-loader@3.6.0_webpack@4.44.2/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".distance {\n  display: inline-flex !important;\n  align-items: center;\n  white-space: nowrap;\n}\n.distance .distance-icon {\n  padding: 0 5px 0 0;\n}\n.distance .svg-icon.svg-location-2 {\n  height: 16px;\n  width: auto;\n  margin: -2px 8px 0 0;\n  flex: 0 0 16px;\n}\n.distance.md-icon .svg-icon.svg-location-2 {\n  height: 24px;\n  width: auto;\n  flex: 0 0 24px;\n}\n", ""]);
// Exports
module.exports = exports;
